import { computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleConfig } from '@rebuild/hooks/data/useModuleConfig';
import { useFinanceMap } from './useFinanceMap';
import { useFinanceChartOption } from './useFinanceChartOption';

export function useFinanceData() {
	const { config, loadModuleConfig } = useModuleConfig();
	const getConfigTab = computed(() => config.value?.tab || []);
	function loadConfig() {
		return loadModuleConfig('finance_data');
	}

	const { main_index, balance_sheet, profit_statement, cash_flow_statement } = useModuleData();

	const moduleIndexMap = new Map([
		['main_index', main_index],
		['balance_sheet', balance_sheet],
		['profit_statement', profit_statement],
		['cash_flow_statement', cash_flow_statement]
	]);
	async function loadData(type, reportType) {
		const module = moduleIndexMap.get(type);
		if (module) {
			const paramMap = {
				main_index: { reportTypeYOY: reportType },
				balance_sheet: { reportType },
				profit_statement: { reportTypeYOY: reportType },
				cash_flow_statement: { reportType }
			};
			const params = paramMap[type];
			await module.refresh(params);
			return module.data;
		}
		return {};
	}
	function getModuleState(type) {
		const module = moduleIndexMap.get(type);
		if (!module) return {};
		const moduleData = module.data?.data || [];
		return {
			loading: module.loading,
			isEmpty: moduleData?.length === 0
		};
	}

	const { getModuleMap } = useFinanceMap();
	const { getChartOption } = useFinanceChartOption();

	function getChartDataFunc(type) {
		const chartConfigs = {
			main_index: (id, data) => {
				const main_index = getConfigTab.value.find(item => item.id === 'main_index');
				const activeTabItem = main_index?.subTabList?.find(tab => tab.id === id);

				const moduleMap = getModuleMap('main_index');
				const configItem = moduleMap[id];
				if (configItem) {
					configItem.name = activeTabItem?.name;
				}
				return getChartOption('main_index', id, data, configItem);
			},
			balance_sheet: (id, data) => {
				const moduleMap = getModuleMap('balance_sheet');
				return getChartOption('balance_sheet', id, data, moduleMap);
			},
			profit_statement: (id, data) => {
				const profit_statement = getConfigTab.value.find(item => item.id === 'profit_statement');
				const activeTabItem = profit_statement?.subTabList?.find(tab => tab.id === id);

				const moduleMap = getModuleMap('profit_statement');
				const configItem = moduleMap[id];
				if (configItem) {
					configItem.name = activeTabItem?.name;
				}
				return getChartOption('profit_statement', id, data, configItem);
			},
			cash_flow_statement: (id, data) => {
				const moduleMap = getModuleMap('cash_flow_statement');
				return getChartOption('cash_flow_statement', id, data, moduleMap);
			}
		};
		return chartConfigs[type];
	}

	return {
		config,
		getConfigTab,

		loadConfig,
		loadData,
		getModuleState,
		getChartDataFunc
	};
}
